import PropTypes from "prop-types";
import { Popper, Paper, ClickAwayListener } from "@mui/material";

function PopperComponent({
  open,
  anchorEl,
  onClose,
  children,
  zIndex = 1400,
  minWidth = 180,
  maxHeight = 300,
  fontFamily = "inherit",
  // eslint-disable-next-line logical-direction/no-physical-margin-padding
  placement = "left-start",
  paperSx = {},
  paperProps = {},
  ...rest
}) {
  return (
    <Popper open={open} anchorEl={anchorEl} placement={placement} style={{ zIndex }} {...rest}>
      <ClickAwayListener onClickAway={onClose}>
        <Paper
          onMouseLeave={onClose}
          sx={{
            border: "1px solid #ECF3FE",
            backgroundColor: "#FFFFFF",
            boxShadow: "4px 4px 15px rgba(65, 92, 171, 0.15)",
            minWidth,
            maxHeight,
            overflowY: "auto",
            fontFamily,
            "& *": { fontFamily: "inherit" },
            ...paperSx,
          }}
          {...paperProps}
        >
          {children}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
}

PopperComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  anchorEl: PropTypes.any,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  zIndex: PropTypes.number,
  minWidth: PropTypes.number,
  maxHeight: PropTypes.number,
  fontFamily: PropTypes.string,
  placement: PropTypes.string,
  paperProps: PropTypes.object,
  paperSx: PropTypes.object,
};

export default PopperComponent;
